export const iconFontAwesomeAstronomyMoon = (
	<i className="fa-solid fa-moon"></i>
);
